// extracted by mini-css-extract-plugin
export var modalBox = "C_vC";
export var backdrop = "C_vD";